import audioPlay from "../assets/images/icons/audio-play.svg";
import bottomLocation from "../assets/images/icons/progress/bottom.svg";
import centerLocation from "../assets/images/icons/progress/center.svg";
import topLeftLocation from "../assets/images/icons/progress/top-left.svg";
import nextDouble from "../assets/images/icons/next-double.svg";
import Brand from "../components/Brand";
import Controls from "../components/Controls";
import { useTranslation } from "../components/Localization";

export default function ExplanationPage() {
  const { t } = useTranslation();
  return (
    <main className="screen setup explanation-page">
      <section className="top-title">
        <Brand compact />
        <h1>{t("explanation.title")}</h1>
      </section>
      <div className="how">{t("explanation.how")}</div>
      <section className="explanation-steps" aria-label={t("explanation.how")}>
        <div className="explanation-step">
          <img className="explanation-play-icon" src={audioPlay} alt="" />
          <p>{t("explanation.listen")}</p>
        </div>
        <div className="explanation-step">
          <img className="explanation-next-icon" src={nextDouble} alt="" />
          <p>{t("explanation.tasks")}</p>
        </div>
        <div className="explanation-step">
          <div className="explanation-location-graphics" aria-hidden="true">
            <img src={topLeftLocation} alt="" />
            <img src={centerLocation} alt="" />
            <img src={bottomLocation} alt="" />
          </div>
          <p>{t("explanation.icons")}</p>
        </div>
        <div className="explanation-step explanation-step-without-icon">
          <p>{t("explanation.instructions")}</p>
        </div>
      </section>
      <Controls backTo="/tarlatvezetes" nextTo="/rezidencia" />
    </main>
  );
}
